import { useState } from 'react';
import './App.css';
import Build from './components/Build';
import CircuitBackground from './components/CircuitBackground';
import Download from './components/Download';
import Feedback from './components/Feedback';
import Features from './components/Features';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import QuickStart from './components/QuickStart';
import Security from './components/Security';
import { siteContent } from './siteContent';

function App() {
  const [language, setLanguage] = useState('zh');
  const [theme, setTheme] = useState('dark');
  const content = siteContent[language];

  const toggleLanguage = () => {
    setLanguage((current) => (current === 'zh' ? 'en' : 'zh'));
  };

  const toggleTheme = () => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div className="app" data-theme={theme} data-language={language}>
      <CircuitBackground />
      <main className="site-shell">
        <Navbar
          content={content.nav}
          theme={theme}
          onToggleTheme={toggleTheme}
          onToggleLanguage={toggleLanguage}
        />
        <Hero content={content.hero} />
        <QuickStart content={content.start} />
        <Features content={content.features} />
        <Download content={content.download} />
        <Security content={content.security} />
        <Build content={content.build} />
        <Feedback content={content.feedback} />
        <Footer content={content.footer} navLinks={content.nav.links} />
      </main>
    </div>
  );
}

export default App;
